package com.wintermar.inspection.core.ui.component.location

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.location.util.LocationModel
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.save
import org.jetbrains.compose.resources.stringResource

@Composable
fun LocationDialog(
    title: String,
    show: Boolean = false,
    address: String = "",
    onDismiss: () -> Unit,
    onSave: (String, LocationModel?) -> Unit
) {
    var selectedValue by remember { mutableStateOf(address) }
    var locationModel by remember { mutableStateOf<LocationModel?>(null) }

    ModalDialog(
        show = show,
        title = title,
        onDismiss = onDismiss,
        action = ModalAction.default().copy(
            showAction = true,
            withBackgroundHeader = true,
            widthButtonBasedOnText = true,
            label = stringResource(Res.string.save),
            onClick = {
                onSave(selectedValue, locationModel)
                onDismiss()
            }
        )
    ) { verticalPadding ->
        LazyColumn {
            item {
                Spacer(modifier = Modifier.height(verticalPadding))
            }
            item {
                Location(
                    address = address,
                    onChanged = { address, location ->
                        selectedValue = address
                        locationModel = location
                    }
                )
            }
            item {
                Spacer(modifier = Modifier.height(verticalPadding))
            }
        }
    }
}
